import BaseFileData from "@/pages/takeoff/context/project-organisation/models/base-file-data.ts";
import ProjectFileReducerAction from "./project-file-reducer-action.ts";

const fileReducer = (
    draft: BaseFileData,
    action: ProjectFileReducerAction
): BaseFileData => {
    switch (action.type) {
        case 'change-origin':
            draft.setOrigin(action.origin.id);
            draft.setDirtyFlag(true);
            break;
        case 'add-origin':
            draft.addOrigin(action.origin);
            draft.setOrigin(action.origin.id);
            draft.setDirtyFlag(true);
            break;
        case 'delete-origin':
            draft.deleteOrigin(action.originId);
            draft.setDirtyFlag(true);
            break;
        case 'set-origin':
            draft.setOrigin(action.originId);
            break;
        case 'set-dirty-flag':
            draft.setDirtyFlag(action.isDirty);
            break;
        case 'reset':
            return action.data;
        default:
            throw new Error('Unknown action type');
    }

    return draft;
}

export default fileReducer;